export default function Marquee({ text = "Tools built for home education", separator = "✳" }) {
  const item = (
    <span className="mx-8 inline-flex items-center gap-8">
      <span className="font-display text-5xl md:text-7xl font-extrabold uppercase tracking-tight text-cream">
        {text}
      </span>
      <span className="font-display text-5xl md:text-7xl font-extrabold text-turquoise">{separator}</span>
    </span>
  );
  return (
    <div className="overflow-hidden bg-purple py-8 border-y-2 border-charcoal/20" data-testid="marquee">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        <div className="flex">{Array.from({ length: 6 }).map((_, i) => <span key={i}>{item}</span>)}</div>
        <div className="flex" aria-hidden="true">{Array.from({ length: 6 }).map((_, i) => <span key={`b${i}`}>{item}</span>)}</div>
      </div>
    </div>
  );
}
